import { apiClient } from "src/careflow/ph-core/api_client/api_client";

const goalBaseUrl = '/goal';

export const createGoal = async (payload: any): Promise<any> => {
  try {
    const data = await apiClient.post(goalBaseUrl, payload);
    return data;
  } catch (error) {
    return false;
  }
};

export const editGoal = async (payload: any, goalId: string): Promise<any> => {
  try {
    const data = await apiClient.put(`${goalBaseUrl}/${goalId}`, payload);
    return data;
  } catch (error) {
    return false;
  }
};